import React, { useState } from 'react';
import { API_BASE_URL } from '../config/api';

interface ApiResponse {
  status: string;
  message: string;
  timestamp?: string;
  data?: any;
}

export const AwsConnectionTest: React.FC = () => {
  const [testResults, setTestResults] = useState<{[key: string]: ApiResponse | string}>({});
  const [loading, setLoading] = useState<{[key: string]: boolean}>({});

  const testApi = async (endpoint: string, name: string) => {
    setLoading(prev => ({ ...prev, [name]: true }));
    
    try {
      const url = `${API_BASE_URL}${endpoint}`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      setTestResults(prev => ({ ...prev, [name]: data }));
      
    } catch (error) {
      console.error(`❌ ${name} 테스트 실패:`, error);
      setTestResults(prev => ({ 
        ...prev, 
        [name]: `❌ 오류: ${error instanceof Error ? error.message : String(error)}` 
      }));
    } finally {
      setLoading(prev => ({ ...prev, [name]: false }));
    }
  };

  const testAll = () => {
    testApi('/', 'basic');
    testApi('/health', 'health');
    testApi('/api/supabase/test', 'supabase');
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'monospace' }}>
      <h1>🌐 AWS EC2 백엔드 연결 테스트</h1>
      
      <div style={{ marginBottom: '20px', padding: '10px', background: '#f0f0f0', borderRadius: '5px' }}>
        <h3>📡 연결 정보</h3>
        <p><strong>API Base URL:</strong> {API_BASE_URL}</p>
        <p><strong>백엔드 서버:</strong> AWS EC2 (http://3.38.106.218:8000)</p>
        <p><strong>데이터베이스:</strong> Supabase</p>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <button 
          onClick={testAll}
          style={{ 
            padding: '10px 20px', 
            fontSize: '16px', 
            backgroundColor: '#007bff', 
            color: 'white', 
            border: 'none', 
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          🧪 모든 API 테스트 실행
        </button>
      </div>

      <div style={{ display: 'grid', gap: '20px', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))' }}>
        {/* 기본 API 테스트 */}
        <div style={{ padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
          <h3>🏠 기본 API</h3>
          <button 
            onClick={() => testApi('/', 'basic')}
            disabled={loading.basic}
            style={{ padding: '5px 10px', marginBottom: '10px' }}
          >
            {loading.basic ? '테스트 중...' : 'GET /'}
          </button>
          <div style={{ background: '#f8f9fa', padding: '10px', borderRadius: '3px', fontSize: '12px' }}>
            <pre>{JSON.stringify(testResults.basic, null, 2)}</pre>
          </div>
        </div>

        {/* 헬스체크 테스트 */}
        <div style={{ padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
          <h3>❤️ 헬스체크</h3>
          <button 
            onClick={() => testApi('/health', 'health')}
            disabled={loading.health}
            style={{ padding: '5px 10px', marginBottom: '10px' }}
          >
            {loading.health ? '테스트 중...' : 'GET /health'}
          </button>
          <div style={{ background: '#f8f9fa', padding: '10px', borderRadius: '3px', fontSize: '12px' }}>
            <pre>{JSON.stringify(testResults.health, null, 2)}</pre>
          </div>
        </div>

        {/* Supabase 연결 테스트 */}
        <div style={{ padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
          <h3>🗃️ Supabase 연결</h3>
          <button 
            onClick={() => testApi('/api/supabase/test', 'supabase')}
            disabled={loading.supabase}
            style={{ padding: '5px 10px', marginBottom: '10px' }}
          >
            {loading.supabase ? '테스트 중...' : 'GET /api/supabase/test'}
          </button>
          <div style={{ background: '#f8f9fa', padding: '10px', borderRadius: '3px', fontSize: '12px' }}>
            <pre>{JSON.stringify(testResults.supabase, null, 2)}</pre>
          </div>
        </div>
      </div>

      <div style={{ marginTop: '30px', padding: '15px', background: '#e7f3ff', borderRadius: '5px' }}>
        <h3>📝 테스트 결과 요약</h3>
        <ul>
          <li><strong>기본 API:</strong> {testResults.basic ? '✅ 성공' : '⏳ 대기'}</li>
          <li><strong>헬스체크:</strong> {testResults.health ? '✅ 성공' : '⏳ 대기'}</li>
          <li><strong>Supabase:</strong> {testResults.supabase ? '✅ 성공' : '⏳ 대기'}</li>
        </ul>
      </div>
    </div>
  );
};